module.exports = __webpack_public_path__ + "static/media/cuenta.1f65f1af.png";